import { OmekaMedia } from '../../../lib/generalTypes';
import { isOmekaMediaType, readableBytes } from '../../../lib/helperFuncs';

export const getMediaAndMetadata = (data: any) => {
  const images = data.map((x: any) => {
    if (isOmekaMediaType(OmekaMedia.Image, x)) {
      return {
        mediaId: x['o:id'],
        url: x['thumbnail_display_urls']?.['large'],
        thumbnail: x['thumbnail_display_urls']?.['square'],
      };
    }
  }).filter((a: any) => a);
    
  const videos = data.map((x: any) => {
    if (isOmekaMediaType(OmekaMedia.Video, x)) {
      return {
        mediaId: x['o:id'],
        url: x['o:original_url'],
        thumbnail: `${process.env.REACT_APP_OMEKA_URL}${x['thumbnail_display_urls']?.['medium']}`,
      };
    }
  }).filter((a: any) => a);

  const attachments = data.map((x: any) => {
    if (isOmekaMediaType(OmekaMedia.Attachments, x)) {
      return {
        mediaId: x['o:id'],
        url: x['o:original_url'],
        fileName: x['o:source'] || x['o:title'],
        size: `${readableBytes(x['o:size'])} MB`,
      };
    }
  }).filter((a: any) => a);

  return { images, videos, attachments };
};

export const mapOmekaMediaMetadata = (omekaData: any, selectedId: number | undefined) => {
  let mediaTitle, mediaSize, mediaHeight, mediaWidth;
  omekaData.map((item: any) => {
    
    if (item?.['o:id'] === selectedId) {
      mediaTitle = item?.['o:source'] || item?.['o:title'];
      mediaSize = `${readableBytes(item?.['o:size'])} MB`;
      mediaHeight = item?.['attachedmedia:mediaHeight']?.map((media: any) => media?.['@value']) || '-';
      mediaWidth = item?.['attachedmedia:mediaWidth']?.map((media: any) => media?.['@value']) || '-';
    }
  });

  return { mediaTitle, mediaSize, mediaHeight, mediaWidth };
};